import { IStoreState } from '../../types'
import { RouteComponentProps } from 'react-router'
import {
  getServiceProgram,
  getServiceProgramProcessingError
} from '../../state/reducers/service-program/service-program'
import { deleteServiceProgram } from '../../state/actions/service-program/service-program'
import { connect } from 'react-redux'
import ServiceProgramRemoveModal from '../../components/global-settings/ServiceProgramRemoveModal'

const mapStateToProps = (state: IStoreState, ownProps: RouteComponentProps<any>) => {
  return {
    serviceProgram: getServiceProgram(state, ownProps.match.params.id),
    routeProps: ownProps,
    error: getServiceProgramProcessingError(state)
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onRemove: (id: string) => {
      return dispatch(deleteServiceProgram(id))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceProgramRemoveModal)



// WEBPACK FOOTER //
// ./src/containers/service-program/ServiceProgramRemoveModal.ts